<template>
  <div id="pers-tab16" name="hres31x-tab16" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">
    <template v-for="(value, index) in detail.tableChangeName.rows">
      <detail-template
        :index="index"
        :labels="labels"
        :detail="detail"
        inline-template>
        <div>
          <div slot="head" class="sub-topic-box color-skin" @click="toggleDisp()">
            <i class="fa fa-pencil-square-o icon-sub-topic" aria-hidden="true"></i>
            <div class="sub-topic">{{ labels['HRES31XC14']['10'] }} ( {{ labels['HRES31XC19']['20'] }}  {{ index + 1 }} )</div>
          </div>

          <div slot="body" class="data-pers-box" v-show="topicDisp">
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC14']['20'] }}</div>
              <div class="col-xs-6 data-text">{{ setDateOutput(value.dtechg) }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC14']['30'] }}</div>
              <div class="col-xs-6 data-text">{{ value.namtitle }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC14']['40'] }}</div>
              <div class="col-xs-6 data-text">{{ value.namfirste }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC14']['50'] }}</div>
              <div class="col-xs-6 data-text">{{ value.namlaste }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC14']['60'] }}</div>
              <div class="col-xs-6 data-text">{{ value.deschang }}</div>
            </div>
          </div>
        </div>
      </detail-template>
    </template>
  </div>
</template>

<script>
import detailTemplate from 'components/hres31x/detailTemplate'

export default {
  name: 'hres31x-tab16',
  components: {
    detailTemplate
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>


// WEBPACK FOOTER //
// tab16.vue?1e18eab0